import type { EmployeeUnavailabilityResponse } from "./EmployeeUnavailabilityResponse";
import type { EmployeeUnavailabilityRequest } from "./EmployeeUnavailabilityRequest";

export class EmployeeUnavailabilityListItem {
  unavailabilityId: number;
  employeeId: number;
  employeeName: string;
  reasonLookupId: number;
  reasonName: string;
  startTime: string;
  endTime: string;
  notes: string | null;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;

  constructor(response: EmployeeUnavailabilityResponse) {
    this.unavailabilityId = response.unavailabilityId;
    this.employeeId = response.employeeId;
    this.employeeName = response.employeeName;
    this.reasonLookupId = response.reasonLookupId;
    this.reasonName = response.reasonName;
    this.startTime = response.startTime;
    this.endTime = response.endTime;
    this.notes = response.notes;
    this.createdDate = response.createdDate;
    this.createdBy = response.createdBy;
    this.modifiedDate = response.modifiedDate;
    this.modifiedBy = response.modifiedBy;
  }

  toRequest(): EmployeeUnavailabilityRequest {
    return {
      employeeId: this.employeeId,
      reasonLookupId: this.reasonLookupId,
      startTime: this.startTime,
      endTime: this.endTime,
      notes: this.notes
    };
  }
}
